import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { unboxLabel } from '../Configurations';
import { optionFilterBySystem } from '../inputs/ConfigurationSelect';
import { ConfigurationSelect } from '../inputs/ConfigurationSelect';
import { ConfigurationComponent } from '.';

const SealOptionsConfig = () => (
  <ConfigurationSelect
    configurationKey="sealOptions"
    dispatchAction="SET_SEAL_OPTIONS"
    optionsFilterFn={optionFilterBySystem}
  />
);

const config: ConfigurationComponent<'sealOptions'> = {
  key: 'sealOptions',
  input: <SealOptionsConfig />,
  display: (value: ConfigurationValues['sealOptions']) => (
    <span>{unboxLabel(value.label)}</span>
  ),
};

export default config;
